import { MakeDictionary } from 'SharedDir/utils/helpers';

export enum IssueStatus {
  template = 'template',
  created = 'created',
  in_work = 'in_work',
  completed = 'completed',
  declined = 'declined',
  declinedByIssuer = 'declined_by_issuer',
}

const StatusList = [
  {
    label: 'Черновик',
    value: IssueStatus.template,
  },
  {
    label: 'Подано',
    value: IssueStatus.created,
  },
  {
    label: 'В работе',
    value: IssueStatus.in_work,
  },
  {
    label: 'Завершено',
    value: IssueStatus.completed,
  },
  {
    label: 'Отклонено',
    value: IssueStatus.declined,
  },
  {
    label: 'Отменено заявителем',
    value: IssueStatus.declinedByIssuer,
  },
];

export enum IssueStatusTitle {
  'template' = 'Черновик',
  'created' = 'Подано',
  'in_work' = 'В работе',
  'completed' = 'Завершено',
  'declined' = 'Отклонено',
  'declined_by_issuer' = 'Отменено заявителем',
}

export const StatusDict = MakeDictionary(StatusList, 'value', 'label');

export default StatusList;
